import { Dispatch } from 'redux'

import types from './types'

const updatedUnreadNotificationCount = (count: number) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: types.UPDATE_UNREAD_NOTIFICATION_COUNT,
      payload: count,
    })
  }
}

const actions = {
  updatedUnreadNotificationCount,
}
export default actions
